import { Length, Matches } from 'class-validator';

import { passwordRegexp } from '@onArte/shared/regexp';

export class ResetPasswordModel {
  @Length(8, 64)
  @Matches(passwordRegexp)
  public password: string;

  constructor(
    public token: string,
    password: string,
  ) {
    this.password = password;
  }
}
